import { render, staticRenderFns } from "./ReviewCriteriaList.vue?vue&type=template&id=b6432900&scoped=true&"
import script from "./ReviewCriteriaList.vue?vue&type=script&lang=js&"
export * from "./ReviewCriteriaList.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCriteriaList.vue?vue&type=style&index=0&id=b6432900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6432900",
  null
  
)

export default component.exports